module.exports = ".loading {\n  text-align: center;\n  font-size: 16px;\n  color: #888;\n  border: 1px solid #ebeef2;\n  padding: 15px;\n  border-radius: 2px; }\n\n.custom-button {\n  padding: 0px !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/datagrid/datagrid.component.scss
// module id = ./src/app/components/datagrid/datagrid.component.scss
// module chunks = main